module.exports = __webpack_public_path__ + "static/victor_bjorklund-59baacac8d12d2960ab44294f826ecc3.png";